module.exports = __webpack_public_path__ + "static/media/glanum_weinraeucherei.973d5fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_weinraeucherei.png
// module id = 725
// module chunks = 0